import styles from './ContactButtonArea.module.scss'

const ContactButtonArea: React.VFC = () => {
  return (
    <>
      <section className={styles.contact}>
        <div className={styles.wrapper}>
          <p className={styles.textTop}>Contact</p>
          <p className={styles.textMiddle}>まずはお気軽にご相談ください。</p>
          <a className={styles.toContactButton} href="#Contact">
            お問い合わせ
            <span className={styles.mailIcon}></span>
          </a>
        </div>
      </section>
    </>
  )
}

export default ContactButtonArea
